import PropTypes from 'prop-types';
import React from 'react';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { siteMapPropType } from '@bingads-webui-react/with-site-map';
import { ReactObservablePromise } from '@bingads-webui-react/react-observable-promise';
import { withServerContext } from '@bingads-webui-campaign-react/server-context';
import { isCopilotRegionRestricted } from '@bingads-webui-react/copilot-utils';

import { filterMapItem } from './processor-helpers';

const defaultRestriction = false;

const getFilteredSiteMap = (items, isRegionRestricted) => filterMapItem(items, ({ copilotFeature }) => !copilotFeature || !isRegionRestricted);

export function processCopilotRegionRestriction(Component) {
  const Wrapper = ({ siteMap, ...props }) => {
    const { serverContext, permissions } = props;

    const processor = (isRegionRestricted) => {
      const filteredSiteMap = getFilteredSiteMap(siteMap, isRegionRestricted);
      return <Component {...props} siteMap={filteredSiteMap} />;
    };

    return (
      <ReactObservablePromise
        promise={() => isCopilotRegionRestricted({ feature: 'FullPageFeature', permissions, serverContext })}
        promiseHashFn={() => 'isCopilotRegionRestricted'}
        fallback={processor(defaultRestriction)}
        onError={() => processor(defaultRestriction)}
      >
        {isRegionRestricted => processor(isRegionRestricted)}
      </ReactObservablePromise>
    );
  };

  Wrapper.propTypes = {
    siteMap: siteMapPropType.isRequired,
    permissions: PropTypes.shape({}).isRequired,
    serverContext: PropTypes.shape({ }).isRequired,
  };

  return withServerContext(withPermissions(Wrapper));
}
